exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#div_message .form-textarea{\n  width: 85% !important;\n}\n\n#div_message .div-header{\n  background-color: #fcfcfc;\n  padding-bottom: 15px;\n  padding-top: 12px;\n}\n\n#div_message .span_div_message{\n    color: #9b9b9b;\n}\n\n#div_message md-dialog-container{\n  border: 1px solid #dadada !important;\n  padding: 20px !important;\n  overflow: hidden !important;\n  border-radius: 4px !important;\n  margin-top:40px !important;\n}\n\n#div_message md-dialog-content {\n  margin-top: -10px !important;\n}\n\n.ng-invalid {\n  border-color: red;\n}\n\n.dropdown-item.active{\n  color: #fff !important;\n  background-color: #00c0c2 !important;\n}\n\n.button-ddd {\n  color: #fff !important;\n  background-color: #00c0c2 !important;\n}\n\n.button-ddd.active {\n  color: #fff !important;\n  background-color: #00c0c2 !important;\n}\n\n.dropdown-item.active span {\n  color: #fff !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/send-message/send-message.component.css
// module id = ../../../../../src/app/pages/send-message/send-message.component.css
// module chunks = main